import { render, staticRenderFns } from "./ProductBatchComponent.vue?vue&type=template&id=4ba3e006"
import script from "./ProductBatchComponent.vue?vue&type=script&lang=js"
export * from "./ProductBatchComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports